import { Theme, makeStyles } from '@forgeglobal/design-framework';

const HEADER_HEIGHT = 64 + 1;

const useStyles = makeStyles((theme: Theme) => ({
  main: {
    minHeight: `calc(100vh - ${HEADER_HEIGHT}px)`,
  },
  mainContainer: {
    maxWidth: 1280,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    margin: '0 auto',
  },
  headerWrapper: {
    background: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  headerWrapperFixed: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
  },
  headerContainer: {
    height: 64,
    padding: theme.spacing(1, 1.5),
  },
  logoContainer: {
    marginLeft: theme.spacing(1.5),
    marginTop: theme.spacing(0.8),
    height: theme.spacing(4),
    width: 143,
  },
  logoLink: {
    height: theme.spacing(4),
    marginRight: 100,
    [theme.breakpoints.down('md')]: {
      marginRight: theme.spacing(4),
    },
  },
}));

export default useStyles;
